import { render, staticRenderFns } from "./GeneralSettingsDateFormatPos.vue?vue&type=template&id=cc5f2fd2&"
import script from "./GeneralSettingsDateFormatPos.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingsDateFormatPos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports